/**
 * EVAS-459 (research doc §5.3, decided 2026-11-03): the returning-browser token.
 *
 * A random, opaque token the widget keeps in the host site's own localStorage, only after the visitor ticked
 * the device-recognition box, and sends with the join. It holds no personal data: the host page's own scripts
 * can read it. The join keeps only its hash (SHA-256 over the company id and the token), which the agent uses
 * as device evidence beside the fingerprint, within the company only.
 */
/** The localStorage key the widget keeps the token under: one per embedding, on the host site's origin. */
export function browserTokenKey(embedKey) {
    return `evas:${embedKey}`;
}
/** A token as the widget makes it: 16 random bytes, base64url without padding, so 22 characters. */
export const BROWSER_TOKEN_PATTERN = /^[A-Za-z0-9_-]{22}$/;
/** Whether a value is a token the widget could have made. Anything else is dropped, never refused. */
export function isBrowserToken(v) {
    return typeof v === "string" && BROWSER_TOKEN_PATTERN.test(v);
}
/** The hash the database keeps, as the join computes it: SHA-256 hex over the company id, ":" and the token.
 * The company id in it means one token could never find a participant of another company, even if two
 * companies' widgets shared a site. */
export const BROWSER_TOKEN_HASH_PATTERN = /^[0-9a-f]{64}$/;
//# sourceMappingURL=browser-token.js.map